import "@/App.css";
import { Fragment } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import HomesForSale from "@/pages/HomesForSale";
import ForRent from "@/pages/ForRent";
import ListingDetail from "@/pages/ListingDetail";
import Directory from "@/pages/Directory";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminListings from "@/pages/admin/AdminListings";
import ListingEditor from "@/pages/admin/ListingEditor";
import AdminDirectory from "@/pages/admin/AdminDirectory";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSlides from "@/pages/admin/AdminSlides";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import AdminPosts from "@/pages/admin/AdminPosts";
import PostEditor from "@/pages/admin/PostEditor";
import AdminPlaces from "@/pages/admin/AdminPlaces";
import AdminRetreats from "@/pages/admin/AdminRetreats";
import Retreats from "@/pages/Retreats";
import About from "@/pages/About";
import RetreatDetail from "@/pages/RetreatDetail";
import SearchPage from "@/pages/Search";
import PlacePage from "@/pages/PlacePage";
import PlacesIndex from "@/pages/PlacesIndex";

const siteRoutes = (p) => (
  <Fragment key={p || "en"}>
    <Route path={p || "/"} element={<Home />} />
    <Route path={`${p}/homes-and-land-for-sale`} element={<HomesForSale />} />
    <Route path={`${p}/for-rent`} element={<ForRent />} />
    <Route path={`${p}/for-rent/:slug`} element={<ListingDetail />} />
    <Route path={`${p}/directory`} element={<Directory />} />
    <Route path={`${p}/services-2`} element={<Navigate to={`${p}/directory`} replace />} />
    <Route path={`${p}/gallery`} element={<Gallery />} />
    <Route path={`${p}/contact`} element={<Contact />} />
    <Route path={`${p}/stories`} element={<Stories />} />
    <Route path={`${p}/stories/:slug`} element={<StoryDetail />} />
    <Route path={`${p}/post/:slug`} element={<StoryDetail />} />
    <Route path={`${p}/search`} element={<SearchPage />} />
    <Route path={`${p}/retreats`} element={<Retreats />} />
    <Route path={`${p}/about`} element={<About />} />
    <Route path={`${p}/retreats/:slug`} element={<RetreatDetail />} />
    <Route path={`${p}/areas`} element={<PlacesIndex kind="area" />} />
    <Route path={`${p}/things-to-do`} element={<PlacesIndex kind="activity" />} />
    <Route path={`${p}/areas/:slug`} element={<PlacePage />} />
    <Route path={`${p}/things-to-do/:slug`} element={<PlacePage />} />
    <Route path={`${p}/:slug`} element={<ListingDetail />} />
  </Fragment>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <LangProvider>
            <Routes>
              <Route element={<SiteLayout />}>
                {siteRoutes("")}
                {siteRoutes("/es")}
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminOverview />} />
                <Route path="listings" element={<AdminListings />} />
                <Route path="listings/:id" element={<ListingEditor />} />
                <Route path="directory" element={<AdminDirectory />} />
                <Route path="gallery" element={<AdminGallery />} />
                <Route path="inquiries" element={<AdminInquiries />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="slides" element={<AdminSlides />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="places" element={<AdminPlaces />} />
                <Route path="retreats" element={<AdminRetreats />} />
                <Route path="posts" element={<AdminPosts />} />
                <Route path="posts/:id" element={<PostEditor />} />
              </Route>
            </Routes>
            </LangProvider>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
